<div class="patient-dropdown-container">
  <div class="patient-dropdown-wrapper">
    <label *ngIf="label && showLabel" [class.required]="required">
      {{ label }}
      <span *ngIf="required" class="required-asterisk">*</span>
    </label>
    <p-dropdown
    class="patient-dropdown-component"
    [options]="patientOptions" 
    [placeholder]="placeholder"
    [showClear]="showClear"
    [filter]="filter"
    filterPlaceholder="Search with Name or MRN"
    filterBy="displayLabel,firstName,lastName,mrn"
    optionLabel="displayLabel" 
    optionValue="id"
    [disabled]="disabled"
    [ngModel]="selectedPatientId"
    (ngModelChange)="onPatientChange($event)">
    <ng-template let-patient pTemplate="item">
      <div class="patient-dropdown-item">
        <i class="pi pi-user patient-icon"></i>
        <span class="patient-name">{{ patient.displayLabel }}</span>
        <span *ngIf="patient.mrn" class="patient-meta-item">
          <i class="pi pi-id-card"></i>
          <span>{{ patient.mrn }}</span>
          </span>
        <span *ngIf="patient.dateOfBirth" class="patient-meta-item">
          <i class="pi pi-calendar"></i>
          <span>{{ patient.dateOfBirth | date:'MM/dd/yyyy' }}</span>
          </span>
        <span *ngIf="patient.gender && patient.gender.trim()" class="patient-meta-item">
          <i class="pi pi-info-circle"></i>
          <span>{{ patient.gender }}</span>
          </span>
      </div>
    </ng-template>
    <ng-template let-patient pTemplate="selectedItem">
      <div class="patient-selected-item">
        <i class="pi pi-user patient-icon-small"></i>
        <span class="selected-name">{{ patient?.displayLabel || placeholder }}</span>
        <span *ngIf="patient?.mrn" class="patient-meta-inline">
          <i class="pi pi-id-card"></i>
          {{ patient.mrn }}
        </span>
      </div>
    </ng-template>
    </p-dropdown>
  </div>
</div>

